import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  Radio,
  RadioGroup,
} from "@mui/material";
import React from "react";
import { StyledLabel } from "../../../common/components/InputLabel";

const IPRInput = ({ register, error, helperText }) => {
  return (
    <React.Fragment>
      <Grid item xs={3} sx={{ marginTop: 1 }}>
        <StyledLabel error={error} id="ipr-permitted-label">
          IPR Permitted
        </StyledLabel>
        <FormHelperText error={error}>{helperText}</FormHelperText>
      </Grid>
      <Grid item xs={9}>
        <FormControl>
          <RadioGroup
            row
            aria-labelledby="ipr-permitted-label"
            name="iprPermitted"
          >
            <FormControlLabel
              value={true}
              control={<Radio {...register("iprPermitted")} />}
              label="Yes"
            />
            <FormControlLabel
              value={false}
              control={
                <Radio {...register("iprPermitted")} sx={{ marginLeft: 8 }} />
              }
              label="No"
            />
          </RadioGroup>
        </FormControl>
      </Grid>
    </React.Fragment>
  );
};

export default IPRInput;
